import { Box } from "@chakra-ui/react";
import NewHireStackedLabel from "features/NewHireJourney/Components/NewHireStackedLabel";

interface ActionPageNewHireHeaderProps {
  newHireJourneyId: string | undefined;
}

export default function ActionPageNewHireHeader({ newHireJourneyId }: ActionPageNewHireHeaderProps) {
  return (
    <Box bg="bg.tertiary" px="5" py="4" borderBottom="1px solid" borderColor="border.default">
      <NewHireStackedLabel journeyId={newHireJourneyId} />
    </Box>
  );
}
